import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
//import { Component, OnInit, ViewChild } from '@angular/core';
import { customfunctions, DataParam } from "../../common/customfunctions";
import { GlobalConstants } from "../../common/global-constants";
import * as ngswal from "sweetalert";
import { NTUserInboxAPIModel } from "./nt-user-inbox-model";
import { ApiMethod } from "../../apimethods/api-method";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpXhrBackend } from "@angular/common/http";
import { ArticleinfoComponent } from "../../articleinfo/articleinfo.component";
import { FileToUpload } from "../../file-upload/file-to-upload.model";
declare var $;

@Component({
  selector: "app-nt-user-inbox",
  templateUrl: "./nt-user-inbox.component.html",
  styleUrls: ["./nt-user-inbox.component.css"]
})
/** Transaction component*/
export class NTUserInbox implements OnInit {
  modelItem = new NTUserInboxAPIModel();

  public progress: number;
  public message: string;
  @Output() public onUploadFinished = new EventEmitter();

  @ViewChild("dataTable") table;
  public aMenuList = [];
  dataTable: any;
  dtOptions: any;

  showModal: boolean;
  showGeneralNotesModal: boolean;
  showHoldModal: boolean;
  showFileUpload: boolean;
  showModalRevert: boolean;
  title: string;
  transId: string;
  articleNo: string;
  articleTitle: string;
  articleType: string;
  //Authors: string;
  author: string;
  authorEMail: string;
  copyright: string;
  copyrightYear: string;
  volume: string;
  issue: string;
  pubDate: string;
  ePubDate: string;
  notes: string;
  monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  selectedFile: string;
  fileCount: number;
  filePath: any;
  dataSet: any;
  uploadTitle: string;
  status: string;
  processName: string;

  journalList: any;
  issueList: any;
  volumeList: any;
  articleList: any;
  parameterStatus: any;

  fileBase64: any;
  file: any;
  fileToUpload: File = null;
  activityList: any;

  ngOnInit() {
    ApiMethod.getBaseUrl();
    this.progress = 0; this.message = "";

    this.route.queryParams
      .subscribe(params => {
        console.log(params); // { orderby: "price" }
        //this.orderby = params.orderby;
        console.log(params.type); // price
        this.parameterStatus = params.type;
      });
  }

  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <NTUserInboxAPIModel>data["NTUserInbox"];
        localStorage.aEID = 0;
        localStorage.articleId = 0;
        this.progress = 0; this.message = "";

        $(".select2").select2({ dropdownParent: '#divFileUpload' });

        $("#lstJournals").select2({
          placeholder: "Select Journal",
          allowClear: true, tags: true,
          dropdownParent: ".card-body"
        });
        $("#lstJournals").val([]).trigger("change");

        $("#lstVolume").select2({
          placeholder: "Select Volume",
          allowClear: true, tags: true,
          dropdownParent: ".card-body"
        });
        $("#lstVolume").val([]).trigger("change");

        $("#lstArticle").select2({
          placeholder: "Select Article",
          allowClear: true, tags: true,
          dropdownParent: ".card-body"
        });
        $("#lstArticle").val([]).trigger("change");

        // this.getJournalsList();

        this.getTransationList();
        customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  getTransationList() {
    $("#LoadingImage").show();

    var fromDate = $("#Txt_FromDate").val();
    var toDate = $("#Txt_ToDate").val();

    var stageName = "";
    if (this.parameterStatus == "prd") {
      stageName = "Pagination";
      fromDate = "";
    }
    else if (this.parameterStatus == "proof") {
      stageName = "AuthorProof";
      fromDate = "";
    }

    var transactionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      //FromDate: fromDate,
      //ToDate: toDate,
      Journals: $("#lstJournals").val(),
      Volume: $("#lstVolume option:selected").text(),
      Issue: $("#lstArticle").val() == null ? "" : $("#lstArticle").val(),
      //Stage: stageName
    };

    ApiMethod.postMethod(this.modelItem.GetNTUserInboxListAPI, transactionData).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.journalList = result.aAllocateJournalList;
        this.dataSet = JSON.stringify(result.aAllocateArticleList);
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 220);
        dataItem.modulename = 'UserListInbox';
        dataItem.infoPopupID = 'ArticleID';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
  start() {
    ngswal({
      title: "Start Transaction",
      text: "Do you want to start this transaction ?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Start!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnStartConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel!", "warning");
        }
      });
  }

  startConfirm() {
    $("#LoadingImage").show();

    var transactionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      TransId: localStorage.aEID
    };
    ApiMethod.postMethod(this.modelItem.StartNTUserAPI, transactionData).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.hide();
        if (result.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Started !",
            text: result.statusMessage,
            showConfirmButton: false,
            timer: 1500
          });
          this.getTransationList();
        } else {
          ngswal("Failed !", result.statusMessage, "warning");
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
  getFiltered() {
    this.getTransationList();
  }

  resetFilter() {
    customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
    $("#lstJournals").val(null).trigger("change");
    this.getTransationList();

    $("#lstVolume").val([]).trigger("change");
    $("#lstArticle").val([]).trigger("change");
  }
  showInfoPopUp(): void {
    $('#btnPopupartMeta').trigger('click');
  }
  showDetails() {
    $("#LoadingImage").show();

    var transactionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      TransId: localStorage.aEID
    };

    ApiMethod.postMethod(this.modelItem.TransactioDetailsAPI, transactionData).subscribe(
      result => {
        this.transId = localStorage.aEID;
        localStorage.articleId = result.transactionDetails.ID;

        ArticleinfoComponent.ArticleInfo(localStorage.articleId);
        this.showModal = true;

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  hide() {
    this.showModal = false;
    $("#divFileUpload").hide();
    $("#file").val("");
  }

  imageCount: number = 1;
  onImageCountChange(value: number | null) {
    if (!value || value < 1) {
      this.imageCount = 1; // Reset to default
    }
  }

  dateFormat(dateL) {
    try {
      var currentDate = "";

      if (dateL != null) {
        var date = new Date(dateL);

        var day = date.getDate();
        var dayString = day > 9 ? day : '0' + day;
        currentDate = dayString + ' ' + this.monthNames[date.getMonth()] + ' ' + date.getFullYear(); //month_names[date.getMonth()]
      }
      return currentDate;
    } catch (e) {
      return "";
    }
  }

  download() {
    ApiMethod.Downloadfile(this.modelItem.DownloadNTUserArticleFile + '/' + localStorage.aLoginID + '/' + localStorage.aEID);
  }

  showUpload() {
    $('.divUploadFile').show();
    $('.divImageProcess').hide();
    ApiMethod.getMethod(this.modelItem.GetNextActivity + "/" + localStorage.aEID).subscribe(
      result => {
        if (result.aActivityList == null) {
          $('.divUploadFile').hide();
          $('.divImageProcess').show();
        }
        this.activityList = result.aActivityList;
        this.issueList = result.issueList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
    $('#FilePackage').val("");
    $('#doc_testfile').val("");
    this.fileBase64 = null;
    this.file = null;
    $('#ddlNextActivity').val(0).change();
    $("#divFileUpload").show();

  }

  UploadPackage = (files) => {
    if ($('#ddlNextActivity').val() == 0 || $('#ddlNextActivity').val() == null) {
      $("#file").val("");
      ngswal("Warning !", "Please select next process!", "warning");
      return false;
    }
    else {
      if (files.length === 0) {
        return false;
      }
      let fileToUpload = <File>files[0];
      this.progress = 0; this.message = '';
      let ext = fileToUpload.name.toString().split('.').pop().toLowerCase();
      if ($.inArray(ext, ['zip']) == -1) {
        ngswal("Warning !", "Invalid Package format !", "warning");
        return false;
      }
      const formData = new FormData();
      formData.append('file', fileToUpload, fileToUpload.name);
      formData.append('ClientApiUrl', this.modelItem.NTUserCompletedApi);
      formData.append('vendorConfigID', localStorage.aEID);
      formData.append('Id', localStorage.aEID);
      formData.append('LoginId', localStorage.aLoginID);
      formData.append('PublisherId', localStorage.aPubID);
      formData.append('ProcessType', "Upload");
      formData.append('Instruction', $('#TxtRemarks').val().trim());
      formData.append('NextActivityID', $('#ddlNextActivity').val());
      $("#LoadingImagePopup").show();

      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });
      let http = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
      http.post($('base')[0].href + 'api/Endpoint/PostFileClient', formData).subscribe(
        (response: Response) => {

          let msgInfo = ''; let msgDetails = '';
          let result = $(response.headers);
          $.each(result, function (e, val) {
            if (val.key == 'ErrorMessage') {
              msgInfo = 'Warning';
              msgDetails = val.value.toString();
            }
            else if (val.key == 'SuccessMessage') {
              msgInfo = 'Success';
              msgDetails = val.value.toString();
            }
          });
          $("#divFileUpload").hide();

          ngswal(msgInfo, msgDetails, "info");

          $("#LoadingImagePopupQC").hide();
        },
        (error) => {
          console.log(error.message);    // Show error, if any.
          ngswal("Warning !", error.message, "warning");
          $("#LoadingImagePopupQC").hide();
        }
      );
    }
  }

  fileUploadChangeEvent(fileInput: any) {
    this.file = fileInput.currentTarget.files[0];
    if (fileInput.currentTarget.files[0]) {

      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = null;
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);

    }
  }

  UploadFile(imageProcess = 0) {

    if (imageProcess == 1 && $('#TxtImageCount').val() == '') {
      ngswal("Warning !", "Please enter image count !", "warning");
    }
    else if (imageProcess == 0 && $('#doc_testfile').val() == "") {
      ngswal("Warning !", "Please upload a file to proceed !", "warning");
    }
    else if (imageProcess == 0 && ($('#ddlNextActivity').val() == 0 || $('#ddlNextActivity').val() == null)) {
      ngswal("Warning !", "Please select next process !", "warning");
    }
    else {
      $("#LoadingImagePopupQC").show();
      this.filePath = null;

      let file = new FileToUpload();

      file.vendorConfigID = localStorage.aEID;
      file.loginID = localStorage.aLoginID;
      file.publisherID = localStorage.aPubID;
      file.processType = "Upload";
      file.id = localStorage.aEID;
      if (imageProcess == 0) {
        file.fileName = this.file.name;
        file.fileSize = this.file.size;
        file.entryType = "";
        file.instruction = $('#TxtRemarks').val().trim();
        file.dueDate = '';
        file.fileAsBase64 = this.fileBase64;
        file.nextActivityID = $('#ddlNextActivity').val();
      }
      else {
        file.processType = "ImageProcess";
        file.imageCount = $('#TxtImageCount').val();
      }
      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });

      ApiMethod.postMethod(this.modelItem.UploadUserCompletedApi, file).subscribe(
        resonse => {
          $("#divFileUpload").hide();
          if (resonse.status == "Failed") {
            ngswal("Failed !", resonse.message, "warning");

          } else {
            ngswal({
              position: "top-end",
              type: "success",
              title: "Uploaded!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
            this.getTransationList();
          }

          $("#LoadingImagePopupQC").hide();
        },
        error => {
          ngswal("Failed !", error, "warning");
          $("#LoadingImagePopupQC").hide();
        }
      );

    }

  }

  //getJournalsList() {
  //  ApiMethod.getMethod(this.modelItem.GetJournalList + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
  //    result => {
  //      this.journalList = result.aitemJournalList;

  //    }, error => {
  //      $("#LoadingImage").hide();
  //      ngswal("Failed !", error.message, "error");
  //    });
  //}

  getVolumeIssue() {
    var journals = $("#lstJournals").val().toString();
    if (journals != "0") {
      ApiMethod.getMethod(this.modelItem.VolumeIssueListAPI + "/" + journals + "/" + localStorage.aLoginID).subscribe(
        result => {
          this.volumeList = result.aVolIssListL;

          $("#lstArticle").val("0");
          $("#lstArticle").trigger("change");

          $("#lstVolume").val("0");
          $("#lstVolume").trigger("change");
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "error");
        });
    }

  }
  getArticle() {
    var journals = $("#lstJournals").val();
    var volIssue = $("#lstVolume").val().toString();
    ApiMethod.getMethod(this.modelItem.ArticleListAPI + "/" + journals + "/" + volIssue + "/" + localStorage.aLoginID).subscribe(
      result => {
        this.articleList = result.aArticleListL;

        $("#lstArticle").val("0");
        $("#lstArticle").trigger("change");

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  hideRevert() {
    this.showModalRevert = false;
  }
  RevertArticle() {
    this.showModalRevert = true;
  }
  RevertConfirmArticle() {
    if ($('#txt_Remarks').val() == "") {
      ngswal("Warning", "Please enter remark !", "warning");
      return;
    }
    $("#LoadingImagePopup").show();

    var transactionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      TransId: localStorage.aEID,
      Remarks: $('#txt_Remarks').val()
    };
    ApiMethod.postMethod(this.modelItem.RevertNTUserAPI, transactionData).subscribe(
      result => {
        $("#LoadingImagePopup").hide();
        this.hide();
        if (result.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Started !",
            text: result.statusMessage,
            showConfirmButton: false,
            timer: 1500
          });
          this.showModalRevert = false;
          this.getTransationList();
        } else {
          ngswal("Failed !", result.statusMessage, "warning");
        }
      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
}


